import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { SUPPORTED_LANGUAGES, RTL_LANGS } from '../i18n';

const LanguageSelector = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = SUPPORTED_LANGUAGES.find(l => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem('kadmiai_lang', code); } catch (e) {}
    if (RTL_LANGS.includes(code)) {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
    }
    document.documentElement.setAttribute('lang', code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative" data-testid="language-selector">
      <button onClick={() => setOpen(!open)} className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg text-sm transition-colors hover:bg-black/5 dark:hover:bg-white/5" data-testid="lang-toggle" aria-label="Select language">
        <span className="text-base">{current.flag}</span>
        {!compact && <span className="hidden sm:inline text-xs font-medium" style={{ color: 'var(--text-secondary)' }}>{current.label}</span>}
        <span className="text-[10px] font-semibold uppercase tracking-wide" style={{ color: 'var(--text-secondary)' }}>{current.code}</span>
        <ChevronDown className="h-3 w-3" style={{ color: 'var(--text-secondary)' }} />
      </button>
      {open && (
        <div className="absolute top-full mt-1 w-44 rounded-xl overflow-hidden shadow-xl z-50" style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', right: 0 }}>
          {SUPPORTED_LANGUAGES.map(lang => (
            <button key={lang.code} onClick={() => changeLanguage(lang.code)}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm transition-colors ${lang.code === current.code ? 'font-semibold' : ''}`}
              style={{ color: 'var(--text-primary)', background: lang.code === current.code ? 'rgba(30,91,224,0.08)' : 'transparent' }}
              data-testid={`lang-${lang.code}`}>
              <span className="text-lg">{lang.flag}</span>
              <span>{lang.label}</span>
              {lang.code === current.code && <span className="ml-auto text-xs" style={{ color: '#7FB342' }}>✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
